import { render, staticRenderFns } from "./offer-tab.vue?vue&type=template&id=59c1f85c&scoped=true"
import script from "./offer-tab.vue?vue&type=script&lang=js"
export * from "./offer-tab.vue?vue&type=script&lang=js"
import style0 from "./offer-tab.vue?vue&type=style&index=0&id=59c1f85c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c1f85c",
  null
  
)

export default component.exports